import {
  MotorFunnelState,
  MotorStepType,
  MotorFlowType,
  Driver,
  MotorFormAnswer,
  MotorFlowDefinition,
} from 'scenes/motor/types';
import {
  getReviewAdditionalDrivers,
  getReviewMainDriver,
} from 'scenes/motor/selectors';

interface HasIndex {
  index: number;
}

const updateDriver = (array: Driver[], item: Partial<Driver> & HasIndex) => {
  const copy = [...array];
  if (item.index >= 0) {
    copy[item.index] = item as Driver;
  }
  return copy;
};

// Helper function, since adding an additional driver can happen from multiple places
const updateDrivers = (
  funnelState: MotorFunnelState
): Partial<MotorFunnelState> => ({
  step: MotorStepType.ReviewDriverDetails,
  flow: MotorFlowType.ReviewDetails,
  [MotorFlowType.ReviewDetails]: {
    ...funnelState[MotorFlowType.ReviewDetails],
    mainDriver:
      funnelState[MotorFlowType.ReviewDriver].index >= 0
        ? funnelState[MotorFlowType.ReviewDetails].mainDriver
        : funnelState[MotorFlowType.ReviewDriver],
    additionalDrivers: updateDriver(
      funnelState[MotorFlowType.ReviewDetails].additionalDrivers,
      funnelState[MotorFlowType.ReviewDriver]
    ),
  },
});

export const forwardLinks: MotorFlowDefinition = {
  [MotorStepType.Name]: (funnelState: MotorFunnelState) =>
    updateDrivers(funnelState),
};

export const backwardLinks: MotorFlowDefinition = {
  [MotorStepType.Name]: {
    step: MotorStepType.ReviewDriverDetails,
    flow: MotorFlowType.ReviewDetails,
  },
};

export const editDriver = (
  funnelState: MotorFunnelState,
  action: MotorFormAnswer
) => {
  const driverIndex = action.formValues.driverIndex ?? -1;
  return (
    (funnelState.flow !== MotorFlowType.QuoteDetails && {
      step: MotorStepType.Name,
      flow: MotorFlowType.ReviewDriver,
      [MotorFlowType.ReviewDriver]: {
        index: driverIndex,
        ...(driverIndex >= 0
          ? getReviewAdditionalDrivers(funnelState)[driverIndex]
          : getReviewMainDriver(funnelState)),
      },
    }) || {
      step: MotorStepType.Name,
      flow: MotorFlowType.QuoteDetails,
    }
  );
};
